import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import SortOption from '~/constants/common/SortOption';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import useIsFromSearchBar from '~/hooks/srp/useIsFromSearchBar';

export default function useResetSortOnNewSearch() {
  const {
    appliedFilters,
    isSortUserSelected,
    setSortBy,
    setWasAllFiltersCleared,
    wasAllFiltersCleared
  } = useContext(AppliedFiltersContext);
  const isFromSearchBar = useIsFromSearchBar();

  // Read via ref so the effect doesn't re-fire when the user picks a sort
  // (which sets isSortUserSelected = true). That re-fire would be a no-op but
  // would also run on every future filter/source change, defeating the guard.
  const isSortUserSelectedRef = useRef(isSortUserSelected);
  isSortUserSelectedRef.current = isSortUserSelected;

  useSubsequentEffect(() => {
    // wasAllFiltersCleared (set only by the "Clear All" action) is the
    // "new search" signal here, not a blanket "filters are now empty" check
    // — removing the one remaining filter tag via its own control also
    // reaches appliedFilters === {}, but is a refinement, not a new search,
    // so it must not reset a link/query-param-provided sort.
    if (
      (wasAllFiltersCleared || isFromSearchBar) &&
      !isSortUserSelectedRef.current
    ) {
      setSortBy(SortOption.MostPopular);
    }

    if (wasAllFiltersCleared) {
      setWasAllFiltersCleared(false);
    }
  }, [
    appliedFilters,
    isFromSearchBar,
    setSortBy,
    setWasAllFiltersCleared,
    wasAllFiltersCleared
  ]);
}
